import * as React from 'react'
import { AuditBulkImportModal } from './AuditBulkImportModal'
import { Button } from 'antd'
import { AuditStore } from '../EditAuditStore'
import { inject } from 'mobx-react'
import { CurrentCompanyStore } from '../../../../../../stores/CurrentCompanyStore'
import { AuditModels } from '@getgreenline/audits'

interface Props {
  audit: AuditModels.CreateInventoryAudit
  auditStore: AuditStore
  className?: string
}

interface InjectedProps {
  currentCompanyStore?: CurrentCompanyStore
}

interface State {
  isBulkImportModalOpen: boolean
}

@inject('currentCompanyStore')
export class AuditBulkImport extends React.Component<Props & InjectedProps, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      isBulkImportModalOpen: false,
    }
  }

  componentDidMount = () => {
    const { productStore, supplierStore } = this.props.currentCompanyStore!

    if (productStore && !productStore.categories) {
      productStore!.getCategories()
    }

    if (supplierStore && !supplierStore.suppliers) {
      supplierStore!.getSuppliers()
    }
  }

  toggleAuditBulkImportModal = () => {
    this.setState({ isBulkImportModalOpen: !this.state.isBulkImportModalOpen })
  }

  render() {
    const { audit, auditStore, className } = this.props
    const { isBulkImportModalOpen } = this.state

    return (
      <Button className={className} icon='plus' onClick={this.toggleAuditBulkImportModal}>
        <span>Bulk import</span>
        {isBulkImportModalOpen && (
          <AuditBulkImportModal
            audit={audit}
            onHide={() => this.setState({ isBulkImportModalOpen: false })}
            auditStore={auditStore}
          />
        )}
      </Button>
    )
  }
}
